import 'intersection-observer';//intersection-observer兼容
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import React from 'react';
import ReactDOM from 'react-dom';
import '@assets/css/reset.css'
import '@assets/css/common.css'
import '@assets/css/mixins/index.scss'
import '@assets/css/mixins/layout.scss'
import Toast from '@components/Toast';
import Router from './router/index';
import { isInAPP } from '@utils/types';
import ErrorBoundary from '@58fe/ems-plugins/lib/react';

import * as serviceWorker from './serviceWorker';
import { share } from '@utils/wx_share';
import config from './config';

import { compareTime, getHashParams, getURLParameters } from './utils/utils';
// import vConsole from 'vconsole';
// const insvConsole = new vConsole();
window.Toast = Toast;
window.isAPP = !!isInAPP;
window.source = (getHashParams() as any).source || '';
window.dpr = window.devicePixelRatio > 2 ? 3 : 2;
window.__from__ = (getHashParams() as any).from || ((getURLParameters() as any).pageFrom ? (getURLParameters() as any).pageFrom.replace('#/', '') : '') || '';
window.isActivity = compareTime();
window.____global = {
  cityId:-1,
  cityName:'',
  skinType:0
};
setTimeout(()=>{
  share({
    title: config.shareData.title,
    link: config.liveSquareUrl,
    desc: config.shareData.desc,
    imgUrl: config.shareData.imgUrl
  });
},300)
if (window.isAPP) {
  console.log('hide title')
  // window.WBAPP && window.WBAPP.invoke('toggle_title_panel', {
  //   cmd: 'hide',
  //   // "animation": "ease-in",
  //   duration: '0',
  //   contain_status_bar: true,
  //   keep_through: false
  // });
  // window.WBAPP && window.WBAPP.invoke('set_status_bar', {
  //   mode: 'light',
  //   color: '#FFFFFFFF'
  // });
}
if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {

  //process.env.BABEL_ENV="development"
  //开发测试时候 通常会扫码进入 扫码是link 所以跳转到common载体 代码copy自无线common示例页面
  window.isAPP &&
    setTimeout(() => {
      (() => {
        //跳转到common载体
        //获取当前url中的字段
        function queryParams(key: any) {
          var a = document.createElement('a');
          a.href = window.location.href;
          var search = a.search.split('?')[1];
          var paramsAry = search.split('&');

          for (var i = 0, item; (item = paramsAry[i++]); ) {
            if (key === item.split('=')[0]) {
              return item.split('=')[1];
            }
          }
          return undefined;
        }
        var pageTypePlugin = new window.WBAPP.action.Adapter('__page_init__');
        pageTypePlugin.method = function(parmas: any, fn: any) {
          var pagetype = queryParams('pagetype') || 'common';
          // 需要做app版本判断，如果版本低于7.2.0不做处理
          if (
            window.WBAPP.util.compareVersion(
              window.WBAPP.common.appVersion,
              '7.2.0'
            ) < 0 ||
            pagetype !== 'common'
          ) {
            return {
              pass: false,
              params: parmas
            };
          }

          return {
            actionName: 'pagetrans',
            params: {
              action: 'pagetrans',
              tradeline: 'core',
              content: {
                pagetype: 'common',
                url: window.location.href
                //isfinish:true
              }
            }
          };
        };
        pageTypePlugin.install();
        window.WBAPP && window.WBAPP.invoke('__page_init__');
      })();
    }, 500);
}

ReactDOM.render(
  // <React.StrictMode>
  <ErrorBoundary>
    <Router />
  </ErrorBoundary>
    ,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
